export const PAYMENT_SUCCESS_ONE_BENEFITS_CARD = {
    SAVINGS_VALUE: "saving-value",
    BOTTOM_TEXT_1: "bottom-text-1",
    BOTTOM_TEXT_2: "bottom-text-2",
    BOTTOM_TEXT_3: "bottom-text-3",
};
